export const columnData = {
  Code: { name: 'Código', widthCol: '5%' },
  Name: { name: 'Nombre', widthCol: '20%' },
  Description: { name: 'Descripción', widthCol: '50%' },
  PrimaryBankAccount: { name: 'Cuenta Bancaria Primaria', widthCol: '25%' }
}
